import { render } from "./register.vue?vue&type=template&id=7f200125&scoped=true&ts=true"
import script from "./register.vue?vue&type=script&lang=ts"
export * from "./register.vue?vue&type=script&lang=ts"

import "./register.vue?vue&type=style&index=0&id=7f200125&lang=less&scoped=true"

import exportComponent from "/root/workspace/LiYuLoginSaaS_ql2g/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f200125"]])

export default __exports__